import {
  ConnectedCard,
  CreateDebitCardInfo,
  CreateDebitCardResponse,
  CreateExternalDebitCardInfo,
} from '@/types/card'

import { http } from './http'

export const createDebitCard = (body: CreateDebitCardInfo) =>
  http.post<CreateDebitCardResponse>(`payout/v2/worker/debit-cards`, body)

export const deleteDebitCard = (entityId: number) =>
  http.delete(`payout/v2/worker/debit-cards/${entityId}`)

export const verifyDebitCard = (body: CreateDebitCardInfo) =>
  http.post('payout/v2/worker/debit-cards/verify', body)

export const createOnDemandPayCard = (body: CreateExternalDebitCardInfo) =>
  http.post('payout/v2/worker/external-cards', body, {
    params: { type: 'EWA_CARD' },
  })

export const getOnDemandPayCard = () =>
  http.get<ConnectedCard>('payout/v2/worker/external-cards', {
    params: { type: 'EWA_CARD' },
  })

export const deleteOnDemandPayCard = () =>
  http.delete(`payout/v2/worker/external-cards`, {
    params: { type: 'EWA_CARD' },
  })
